import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../../customs/skeleton/main";

const Main = lazy(() => import("../../../components/settings/learningTraining/trainingSchedule/main"));

const TrainingSchedule = () => {
  return (
        <Suspense fallback={<PageSkeleton />}>
          <Main />
        </Suspense>
  );
};

export default TrainingSchedule;

